Controller.$inject = [];

function Controller() {

}

export function HuiPageActions() {
    return {
        restrict: 'E',
        replace: true,
        scope: true,
        bindToController: {},
        controller: Controller,
        controllerAs: '$huiCtrl',
        transclude: true,
        template: ($element, $attrs) => {
            return ` <div class="hui px-4 py-1 hui-page-actions" ng-transclude></div>`;
        }
    };
}